import { useEffect, useState } from "react";
import http from "@/api";
import { CATEGORIES as FALLBACK } from "@/constants";

// Categorías de compra dinámicas (administrables por el admin). Fallback a la constante.
export function useCategories() {
  const [cats, setCats] = useState(FALLBACK);
  useEffect(() => {
    http.get("/categories")
      .then((r) => { if (r.data?.items?.length) setCats(r.data.items); })
      .catch(() => {});
  }, []);
  return cats;
}
